var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePrograms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_456_943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1676 6.41252L21.6676 3.41252C21.6054 3.28772 21.5096 3.18272 21.391 3.10934C21.2725 3.03595 21.1358 2.99707 20.9963 2.99707C20.8569 2.99707 20.7202 3.03595 20.6016 3.10934C20.483 3.18272 20.3873 3.28772 20.3251 3.41252L18.8251 6.41252C18.7741 6.51764 18.7484 6.63321 18.7501 6.75002V23.25C18.7501 23.4489 18.8291 23.6397 18.9697 23.7803C19.1104 23.921 19.3012 24 19.5001 24H22.5001C22.699 24 22.8898 23.921 23.0304 23.7803C23.1711 23.6397 23.2501 23.4489 23.2501 23.25V6.75002C23.2494 6.63261 23.2211 6.51701 23.1676 6.41252ZM21.7501 22.5H20.2501V20.25H21.7501V22.5ZM21.7501 18.75H20.2501V7.50002H21.7501V18.75Z",
    fill: "#2C75C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 3.75C2.25 3.15326 2.48705 2.58097 2.90901 2.15901C3.33097 1.73705 3.90326 1.5 4.5 1.5H22.5C22.5 1.10218 22.342 0.720644 22.0607 0.43934C21.7794 0.158035 21.3978 0 21 0L4.5 0C4.00754 0 3.51991 0.0969966 3.06494 0.285452C2.60997 0.473907 2.19657 0.75013 1.84835 1.09835C1.14509 1.80161 0.75 2.75544 0.75 3.75V20.25C0.75 21.2446 1.14509 22.1984 1.84835 22.9017C2.19657 23.2499 2.60997 23.5261 3.06494 23.7145C3.51991 23.903 4.00754 24 4.5 24H16.5V22.5H4.5C3.90326 22.5 3.33097 22.2629 2.90901 21.841C2.48705 21.419 2.25 20.8467 2.25 20.25V6.75C2.89911 7.23683 3.68861 7.5 4.5 7.5H16.5V6H4.5C3.90326 6 3.33097 5.76295 2.90901 5.34099C2.48705 4.91903 2.25 4.34674 2.25 3.75Z",
    fill: "#2C75C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3H16.5V4.5H7.5V3ZM4.5 3H6V4.5H4.5V3ZM4.5 10.5V13.5C4.5 13.6989 4.57902 13.8897 4.71967 14.0303C4.86032 14.171 5.05109 14.25 5.25 14.25H16.5V12.75H6V11.25H16.5V9.75H5.25C5.05109 9.75 4.86032 9.82902 4.71967 9.96967C4.57902 10.1103 4.5 10.3011 4.5 10.5ZM4.5 16.5H6V18H4.5V16.5ZM7.5 16.5H9V18H7.5V16.5ZM12 16.5H16.5V18H12V16.5Z",
    fill: "#2C75C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_456_943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePrograms);
export default __webpack_public_path__ + "static/media/active-programs.5e09b50b855bb23a5d4b27e4f9617903.svg";
export { ForwardRef as ReactComponent };